import { baseTheme, extendTheme } from '@chakra-ui/react'

const theme = {
  colors: {
    primary: '#2D7DFF',
    background: '#0A1A36',
    black: '#222831',
    white: '#C1CFE8',
  },
}

export default extendTheme(theme)
export { baseTheme }
